<template lang="pug" src="./custom-bg-video.pug"></template>

<script>
import Icon from 'components/icon/icon'
export default {
  // data () {
  //   return {
  //     playing: true
  //   }
  // },
  props: ['props'],
  components: {
    Icon
  },
  methods: {
    // btnFunc (i) {
    //   if (i === '2' && !this.playing) {
    //     this.$el.parentNode.children[0].firstChild.firstChild.play()
    //     this.playing = true
    //   } else if (i === '2' && this.playing) {
    //     this.$el.parentNode.children[0].firstChild.firstChild.pause()
    //     this.playing = false
    //   }
    // },
    openVideo () {
      this.$store.dispatch('VIEW_SHOWVIDEO', true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-bg-video.vue?04a5500f